module.exports = __webpack_public_path__ + "static/media/French.2af0d525.gif";